//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueApexCharts from "vue-apexcharts";

const tooltipConstructor = function (fullData, colors) {
    return function ({
        series, seriesIndex, dataPointIndex, w
    }) {
        let show = false;
        function checkValue(val) {
            if (val !== "N/A") {
                show = true;
            }
            return val;
        }
        const result = `<div at-id="tooltip-container" class="tooltip-container">
        ${fullData.reduce(
        (a, b, index) => (a += `<div at-id="tooltip-column-${index}" class="tooltip-column">
                <div at-id="tooltip-title-${index}" class="tooltip-title" style="background-color:${
                colors[index]
            }">
                    ${checkValue(b.data[dataPointIndex].y)}
                </div>
                <div at-id="overdue-${index}" class="tooltip-item overdue">
                    ${checkValue(b.overdue[dataPointIndex])}
                </div>
                <div at-id="at-risk-${index}" class="tooltip-item at-risk">
                    ${checkValue(b.atRisk[dataPointIndex])}
                </div>
                <div at-id="attention-${index}" class="tooltip-item attention">
                    ${checkValue(b.attention[dataPointIndex])}
                </div>
                <div at-id="on-track-${index}" class="tooltip-item on-track">
                    ${checkValue(b.onTrack[dataPointIndex])}
                </div>
            </div>`),
        ""
    )}     
        </div>`;
        if (show) {
            return result;
        }
        return "";
    };
};

const colorOptions = {
    primary: "#4285F4",
    user: "#A6A9B1",
    team: "#00CC66"
};
let colors = [colorOptions.primary, colorOptions.user];
export default {
    name: "Chart",
    components: {
        apexchart: VueApexCharts
    },
    props: {
        secondary: {
            type: Number,
            default: null
        },
        series: {
            type: Array,
            default() {
                return [];
            }
        },
        timeFramelabels: {
            type: Array,
            default() {
                return [
                    this.$t("dashboard.charts.mondayShort"),
                    this.$t("dashboard.charts.tuesdayShort"),
                    this.$t("dashboard.charts.wednesdayShort"),
                    this.$t("dashboard.charts.thursdayShort"),
                    this.$t("dashboard.charts.fridayShort"),
                    this.$t("dashboard.charts.saturdayShort"),
                    this.$t("dashboard.charts.sundayShort")
                ];
            }
        }
    },
    data() {
        colors = [
            colorOptions.primary,
            colorOptions[this.secondary === null ? "user" : "team"]
        ];
        const customTooltip = tooltipConstructor(this.series, colors);
        return {
            options: {
                colors,
                xaxis: {
                    type: "numeric",
                    labels: {
                        formatter: value => this.timeFramelabels[value],
                        style: {
                            colors: "rgba(65,65,65,.5)",
                            fontSize: "12px",
                            fontFamily:
                                '"Roboto", "-apple-system", "Helvetica Neue", Helvetica, Arial, sans-serif'
                        }
                    },
                    tooltip: {
                        enabled: false
                    },
                    axisTicks: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        style: {
                            color: "rgba(65,65,65,.5)",
                            fontSize: "12px",
                            fontFamily:
                                '"Roboto", "-apple-system", "Helvetica Neue", Helvetica, Arial, sans-serif'
                        }
                    },
                    max(max) {
                        let result = max + Math.ceil(max * 0.1);
                        if (result < 5) {
                            result = 5;
                        }
                        return result;
                    },
                    min: 0,
                    forceNiceScale: true
                },
                grid: {
                    borderColor: "#F1F1F1",
                    yaxis: {
                        lines: {
                            show: false
                        }
                    },
                    xaxis: {
                        lines: {
                            show: true
                        }
                    },
                    padding: {
                        top: 0,
                        right: 30,
                        bottom: 10,
                        left: 20
                    }
                },
                tooltip: {
                    followCursor: true,
                    custom: customTooltip,
                    shared: true
                },
                chart: {
                    id: "vuechart",
                    toolbar: {
                        show: false,
                        autoSelected: "reset"
                    },
                    animations: {
                        enabled: false,
                        animateGradually: {
                            enabled: false
                        },
                        dynamicAnimation: {
                            enabled: false
                        }
                    }
                },
                stroke: {
                    curve: "smooth",
                    width: 3,
                    lineCap: "round"
                },
                fill: {
                    colors,
                    opacity: [0.1, 0.06],
                    type: "solid"
                },
                markers: {
                    size: 4,
                    colors: "#fff",
                    strokeColors: colors,
                    strokeWidth: 3,
                    strokeOpacity: 0.9,
                    fillOpacity: 0,
                    shape: "circle",
                    hover: {
                        sizeOffset: 2
                    }
                },
                legend: {
                    show: false
                }
            },
            colors
        };
    },
    watch: {
        series: {
            handler(newValue) {
                this.rebuildTooltip(newValue, this.secondary);
            }
        }
    },
    methods: {
        rebuildTooltip(series, secondary) {
            colors = [
                colorOptions.primary,
                colorOptions[this.secondary === null ? "user" : "team"]
            ];
            this.options.tooltip.custom = tooltipConstructor(series, colors);
            this.options.markers.strokeColors = colors;
            this.options = { ...this.options, colors };
        }
    }
};
